import axiosInstance from '../axiosInstance';
import { BASE_URL } from '../../utils/ip';

// BASE_URL is the API base (e.g. https://host/api). Strip /api to reach the
// static /uploads mount where geo images are served.
const API_ORIGIN = String(BASE_URL || '').replace(/\/api\/?$/, '');

/** Build a full, displayable URL from a stored geo image path (/uploads/geo/...). */
export const geoImageUrl = (path) =>
  !path ? '' : /^https?:\/\//.test(path) ? path : `${API_ORIGIN}${path}`;

/**
 * Upload a GeoData main image. Returns { success, data: { imageUrl } }.
 * imageUrl is a relative path (/uploads/geo/...) to store on the entity.
 */
export const uploadGeoImage = async (file) => {
  const formData = new FormData();
  formData.append('image', file);
  const res = await axiosInstance.post('/geo/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};
